/**
 * Груз доставлен: статус «Груз доставлен» или любой следующий за ним этап
 * (таможенная очистка, выпуск товара, прибытие, склад получателя).
 * Экспедитор может пропустить сам «Груз доставлен» и сразу поставить «Товар выпущен».
 */
export const DELIVERED_CODES = [
  'DELIVERED',
  'CUSTOMS_CLEARANCE_IN_PROGRESS',
  'GOODS_RELEASED',
  'ARRIVED_AT_DESTINATION',
  'AT_RECEIVER_WAREHOUSE',
];

export function isDeliveredByCodes(codes: (string | undefined)[]): boolean {
  return codes.some(c => !!c && DELIVERED_CODES.includes(c));
}

/**
 * Экспедитор не видит статусы, которые в сделке ставил таможенный брокер
 * (таможенная очистка, выпуск товара и т. п.) — это не его этапы.
 * Остальным ролям события отдаются как есть.
 */
export function visibleActivities<T extends { activityType?: { category?: string } | null; actorRole?: { code?: string } | null }>(
  activities: T[] | null | undefined,
  viewerRoleCode: string | undefined
): T[] {
  const list = activities ?? [];
  if (viewerRoleCode !== 'ROLE_FREIGHT_FORWARDER') return list;
  return list.filter(a => !(a.activityType?.category === 'STATUS' && a.actorRole?.code === 'ROLE_CUSTOMS_BROKER'));
}
